import React from "react";
import { graphql } from "@apollo/client/react/hoc";
import { gql } from "@apollo/client";
import { Loading } from "@website2018/da-dobsonville";
import { Redirect } from "react-router-dom";
import CampaignsTemplate from "../../components/Campaigns/Base";

class CampaignsContainer extends React.Component {
  render() {
    const { error, loading, page } = this.props;

    if (loading) return <Loading />;
    if (error || !page) return <Redirect to={"/not-found"} />;

    return <CampaignsTemplate {...this.props} />;
  }
}

const CAMPAIGNS_QUERY = gql`
  query getCampaigns($site: String!) {
    page(slug: "campaigns") {
      id
      slug
      seo
      excerpt {
        rendered
      }
      title {
        rendered
      }
      content {
        rendered
      }
      featured_media {
        id
        source_url
        title {
          rendered
        }
      }
    }
    latest: campaigns(
      taxonomy: "province"
      term: $site
      meta_key: "campaign_status"
      meta_value: "current"
    ) {
      id
      slug
      title {
        rendered
      }
      excerpt {
        rendered
      }
      featured_media {
        id
        source_url
        title {
          rendered
        }
        media_details {
          sizes {
            medium_large { source_url }
          }
        }
      }
      external {
        status
        link
      }
    }
    archive: campaigns(
      taxonomy: "province"
      term: $site
      meta_key: "campaign_status"
      meta_value: "past"
    ) {
      id
      seo
      slug
      title {
        rendered
      }
      external {
        status
        link
      }
    }
    fallback: campaigns(
      taxonomy: "province"
      term: "national"
      meta_key: "campaign_status"
      meta_value: "past"
    ) {
      id
      seo
      slug
      title {
        rendered
      }
      external {
        status
        link
      }
    }
  }
`;

const withCampaigns = graphql(CAMPAIGNS_QUERY, {
  options: (props) => {
    return {
      variables: {
        site: props.site.province.slug,
      },
    };
  },

  props: ({ data }) => ({ ...data }),
});

export default withCampaigns(CampaignsContainer);
